import { take } from "../util";
export const fromGql = (tracking) => take(tracking, 'id', 'provider', 'trackingId');
export const fromGqlCollection = (trackings) => (trackings === null || trackings === void 0 ? void 0 : trackings.map(fromGql)) || [];
//# sourceMappingURL=TrackingEntry.js.map